import { action, computed, makeObservable } from 'mobx';
import React from 'react';
import {logger, objectPatch} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {GapFillingModel} from '../models';
import {checkAllItems} from './kbt-utils';
import {KbtGapFillingState, KbtGapState, KbtGapStates,} from './models';

export class KbtGapFillingStore {
  constructor(readonly id: number,
              readonly model: GapFillingModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }

  @computed
  get gapFillingState(): KbtGapFillingState | null {
    const states: {[index: string]: KbtGapState} = {};
    const altKbtGapFillingState: KbtGapFillingState = { states };

    this.model.paragraphs.map((value, key) => {
      if (value.items) {
        value.items.map((v, k) => {
          Object.assign(altKbtGapFillingState.states, {[`${key}/${k}`]: {filledWith: '', checkCount: 0, checked: false}});
        })
      } else {
        Object.assign(altKbtGapFillingState.states, {[`${key}/1`]: { filledWith: '', checkCount: 0, checked: false }})
      }
    })
    return this.stateStore.getContentState<KbtGapFillingState>(this.id) ? this.stateStore.getContentState<KbtGapFillingState>(this.id) : altKbtGapFillingState;
  }

  @computed
  get gapStates(): KbtGapStates {
    const kbtGapState: {[index: string]: KbtGapState} = {};
    const altGapFillingState: KbtGapFillingState = { states: kbtGapState };

    this.model.paragraphs.map((value, key) => {
      if (value.items) {
        value.items.map((v, k) => {
          Object.assign(altGapFillingState.states, {[`${key}/${k}`]: { filledWith: '', checkCount: 0, checked: false }})
        })
      } else {
        Object.assign(altGapFillingState.states, {[`${key}/1`]: { filledWith: '', checkCount: 0, checked: false }})
      }
    });
    return this.gapFillingState ? this.gapFillingState.states : altGapFillingState.states;
  }

  @action
  onInputChange = (itemId: string,
                   event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const state = this.gapStates[itemId];
    const updatedGapState: KbtGapState = {
      checked: false,
      checkCount: state.checkCount,
      filledWith: value
    };
    const updatedGapStates = objectPatch(this.gapStates, itemId, updatedGapState);
    this.updateState({states: updatedGapStates});
  };

  @action
  check = () => {
    logger.log('KbtGapFillingStore.check');
    const updated = checkAllItems(this.gapStates);
    this.updateState({states: updated});
  };

  private updateState(state: KbtGapFillingState) {
    this.stateStore.setContentState<KbtGapFillingState>(this.id, state);
  }
}
